import { BillingOption } from '../../../../../../../shared/utils/billing-options';
import {
  DialerSubscriptionPlans,
  PlanPurchaseAction,
  SubscriptionPlans,
} from '../../../../../../../shared/utils/subscription-plans';

export enum UpgradePlanQueryParamsKey {
  Action = 'action',
  Plan = 'plan',
  Period = 'period',
}

export const getPlanIndex = (plans, planId) =>
  plans.findIndex(({ id }) => id === planId);

export const getPlanPeriod = (planCycle: BillingOption) =>
  planCycle === BillingOption.MONTHLY ? '1' : '12';

export const getSubscribeAction = (isUserModifyingSubscription: boolean) =>
  isUserModifyingSubscription
    ? PlanPurchaseAction.Upgrade
    : PlanPurchaseAction.Subscribe;

export const isAnnuallyPlan = (planCycle: BillingOption) =>
  planCycle === BillingOption.ANNUALLY;

export const isQuarterlyPlan = (planCycle: BillingOption) =>
  planCycle === BillingOption.QUARTERLY;

export const getIsDialerUserSubscribed = (planCode) =>
  planCode !== DialerSubscriptionPlans.DIALER_FREE &&
  planCode !== SubscriptionPlans.FREE &&
  planCode !== null &&
  planCode !== undefined &&
  planCode !== '';
